import { Reducer } from "redux";

import { PostPutServiceProviderResponse } from "../models/Api/Service";
import { ServiceProviderDetailDispatchTypes } from "../models/DispatchTypes/Service";
import { ServiceProviderActionDispatchType } from "../constants/Service";

const defaultResponse = {
  referralId: -1,
  referralServiceProviderId: 0,
  serviceProviderId: null,
  providerName: "",
  providerNpi: "",
  streetName1: null,
  streetName2: null,
  providerCity: null,
  providerCounty: null,
  providerState: null,
  zipCode: null,
  userCreated: null,
  providerId: 0,
  plexisOfficeId: 0,
  phone: "",
  extension: null,
  isOutOfNetwork: false,
};

const initialState: PostPutServiceProviderResponse = {
  loading: false,
  response: defaultResponse,
  error: null,
};

const PostServiceProviderReducer: Reducer<
  PostPutServiceProviderResponse,
  ServiceProviderDetailDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case ServiceProviderActionDispatchType.POST_PUT_SERVICE_PROVIDER_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ServiceProviderActionDispatchType.POST_PUT_SERVICE_PROVIDER_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
        error: {},
      };
    }
    case ServiceProviderActionDispatchType.POST_PUT_SERVICE_PROVIDER_RESET: {
      return {
        ...state,
        response: defaultResponse,
        loading: false,
        error: {},
      };
    }
    case ServiceProviderActionDispatchType.POST_PUT_SERVICE_PROVIDER_ERROR: {
      return {
        ...state,
        error: action.response,
        loading: false,
      };
    }
  }
  return state;
};
export default PostServiceProviderReducer;
